<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JxgpB5/tc-custom/9781464210259.jpg?1732132328459" alt="This image is the cover for the book Fogland Point"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fogland Point
      </h1>
      <p class="bookDescription body article font2">
        <p>"Elegant prose, a veritable Chinese box of puzzles, and authentic, well-rounded characters make this a standout." —<i>Publishers Weekly</i> STARRED review</p><p><b>Where memories, realities, and identities blur…</b></p><p>David Hazard wanted nothing more than to forget his renegade family and the foggy New England village "on the wrong side" of Narragansett Bay where he grew up. When sudden tragedy brings him back to Little Compton to care for his grandmother during her struggle with dementia, he discovers her fragile memories may hold the key to a bizarre mystery half a century old—and perhaps to the sudden and brutal murder right next door.</p><p>Once Chief of Police Billy Dyer names her as a witness, Grandma Maggie's recollections become vital. But can they be trusted, especially in a town where everyone has a secret, including David himself?</p><p>The investigation stalls. Then eccentric millionaire Marcus Rhinegold's yacht disappears into the fog, bodies begin to wash ashore, and Maggie's stories come vividly to life, setting off a chain of events both horrifying and hauntingly familiar. Puritans, gun-runners, Mafiosi, and a rogues' gallery from past and present converge in the mists of the bay, challenging Billy with layers of deception. On Christmas Eve, he enlists David in a daring move to uncover the many truths surrounding Fogland Point.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Doug Burgess
      </h2>
      
      <p class="authorDescription body article"><P>Doug Burgess grew up in a small town just across the bay from Little Compton, where his family has lived for over 350 years. He has authored numerous books on maritime history, including Engines of Empire: Steamships and the Victorian Imagination (Stanford University Press, 2016) and The Politics of Piracy (University Press of New England, 2015). He has also published short fiction in Ellery Queen Mystery Magazine and other periodicals. Burgess is a professor of history in Manhattan.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fcd3bc02